/* eslint-disable */
export default [
  "What is a skill I have always wanted?",
  "What is the worst financial decision I've ever made?",
  "What's my weirdest habit?",
  "Oceans or mountains?",
  "What's the best advice I've ever heard?",
  "What do I waste my time on?",
  "When have I felt the most challenged?",
  "What's my favorite quote?",
  "What has been the greatest accomplishment of humankind so far?",
  "What limiting beliefs am I holding on to?",
  "What's my favorite word?",
  "How does sound my inner voice?",
  "What was the highlight of my week?",
  "If I was an animal, what would I be?",
  "What was the highlight of my day?",
  "What am I busy with today?",
  "Do I believe in ghosts?",
  "How can I make this day relevant a year from now?",
  "What do I want to learn in the coming year?",
  "What is my guilty pleasure?",
  "How is my relationship with my parents?",
  "Do I believe in aliens?",
  "Do I like teamwork?",
  "If I could meet anyone in the world, alive or dead, who would it be?",
  "What makes me smile?",
  "What can I do today that I was not capable of a year ago?",
  "What was my nickname?",
  "What's stopping me from pursuing my dreams?",
  "What's my philosophy in life?",
  "What's a word or phrase people use that I just can't stand?",
  "When do I think it's okay to lie?",
  "What's my favorite color?",
  "What was the highlight of my weekend?",
  "How much time do I spend online every day?",
  "What's the craziest job I'd be willing to take?",
  "What gives me goosebumps?",
  "What is the biggest thing I have learned in life?",
  "What is something that amazes me?",
  "What is my most beloved childhood memory?",
  "What is the craziest nightdream I've ever had?",
  "Where do I feel most centered and happy?",
  "What does my name mean?",
  "What is one moment in time I will never forget?",
  "What do I most often choose to ignore about myself?",
  "Am I afraid of letting others get close to me?",
  "Would I rather meet my ancestors or descendants?",
  "What is the top priority in my life right now?",
  "When do I feel most like myself?",
  "Pineapple pizza?",
  "What is my ideal life ten years from now?",
  "What question do I want the answer to?",
  "How can I start creating my ideal career starting today?",
  "Which movie had a significant impact on me?",
  "Has my greatest fear ever come true?",
  "What do I think my real hourly wage is?",
  "What is one thing I love about myself?",
  "Where were I a year ago?",
  "What one thing did I not do that I wanted to do?",
  "What is the next big step I need to take?",
  "When I close my eyes, what do I see?",
  "What is my favorite season?",
  "What do I think is the most important life skill or value my parents taught me?",
  "What is difficult for me now but was easy as a child?",
  "What is the top way I deal with stress?",
  "Who do I sometimes compare myself to?",
  "What is my ideal diet?",
  "What do I owe myself?",
  "What is holding me back most?",
  "Is there something I am still holding on to? Is it time to let it go?",
  "Who are the five people I spend the most time with?",
  "What is the strangest food I have ever tried?",
  "When was the last time I got out of my comfort zone?",
  "What fictional place would I like to visit?",
  "What is the most beautiful sound in the world?",
  "What opportunities am I looking for?",
  "What am I passionate about?",
  "What must a city have to make it an excellent place to live in?",
  "How have I helped someone else recently?",
  "How can I make my life more meaningful, starting today?",
  "What's the most beautiful place I've ever seen?",
  "What do I want to achieve one year from now?",
  "What's my least favorite color?",
  "How can I love myself more today?",
  "Winter or summer?",
  "Where am I living right now — in the past, future, or present?",
  "Ocean or lake?",
  "Who inspires me the most?",
  "What are the times I am most inspired/motivated?",
  "What would I do one year ago differently?",
  "What are the most significant actions I can take now to create the biggest results?",
]
